import Fade from '@mui/material/Fade';
import Grid from '@mui/material/Grid';
import Zoom from '@mui/material/Zoom';
import blueThumb from 'assets/illustrations/Thumbs-up-star.png';
import StdDialog from 'components/Dialogs/StdDialog';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useTimeoutFn } from 'react-use';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(({ typography }) => ({
  root: {
    position: 'relative',
    height: 545,
    alignItems: 'center',
  },
  container: {
    height: 300,
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'column',
  },
  successLabel: {
    ...typography.h5,
    textAlign: 'center',
  },
  successNameLabel: {
    textTransform: 'capitalize',
  },
}));

const WatchlistSuccessModal = (props) => {
  const { open, onClose, name, created } = props;
  const { classes } = useStyles();

  const onHandleClose = useCallback((e) => onClose(e, 'success-modal'), [onClose]);

  useTimeoutFn(onHandleClose, 3000);

  return (
    <StdDialog open={open} onClose={onHandleClose} showCloseButton={false} size='sm'>
      <Grid container className={classes.root}>
        <Grid item container className={classes.container} alignItems='center' justifyContent='center'>
          <Zoom in>
            <img src={blueThumb} alt='Thumb up' width={218} height={218} />
          </Zoom>
          <Fade in timeout={1000}>
            <div className={classes.successLabel}>
              {"You've"} {created ? 'created' : 'updated'} your <span className={classes.successNameLabel}>{name}</span>{' '}
              Watchlist
            </div>
          </Fade>
        </Grid>
      </Grid>
    </StdDialog>
  );
};

WatchlistSuccessModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  name: PropTypes.string,
  created: PropTypes.bool,
};

WatchlistSuccessModal.whyDidYouRender = true;

export default WatchlistSuccessModal;
